import React from 'react';

import { UserProvider } from '../../services/profile';

const DynamicUserProvider = ({ user, loading, children, ...rest }) => (
  <UserProvider value={{ user, loading, ...rest }}>{children}</UserProvider>
);

export default DynamicUserProvider;
